var map = {
	"./Alt_fill_lines.png": "3b64",
	"./Battery.png": "93bf",
	"./Battery_Replacement.png": "af29",
	"./Cassette_Replacement.png": "55c9",
	"./Emptying.png": "50a7",
	"./Emptying_Fluid.png": "a5c0",
	"./Emptying_the_Powder.png": "9658",
	"./Emptying_the_skimmer.png": "dad3",
	"./Filling_the_Tube.png": "1c51",
	"./Follow_the_Instructions.png": "9d3c",
	"./Follow_the_Instructions_on_the_Bottle.png": "e093",
	"./If_there's_liquid_in_the_tube_due_to_overfilling....png": "ec35",
	"./Opening_the_Tube.png": "f213",
	"./Pouring_the_liquid.png": "c056",
	"./Prepare_the_Area.png": "efce",
	"./Preparing_the_Area.png": "1ef0",
	"./Pump_Speed.png": "0ffd",
	"./Sensor_Height.png": "9a23",
	"./Skimmer_Size.png": "61e1",
	"./Video.png": "da23",
	"./Water_Test.png": "851a",
	"./WiFi.png": "7f20",
	"./WiFi_Availability.png": "4f24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9570";